<template>
  <div class="col-12">

    <div class="row mt-3">
      
      <div :class="{'col-9': xLabels.length >= 3 && measurements.tasksChart.length === 1, 'col-12': xLabels.length < 3 || measurements.tasksChart.length !== 1 }" v-if="measurements && xLabels">
        <line-chart class="row" v-bind:datasets="dataset"
                    v-if="xLabels.length"
                    :chart-id="'stageChart_' + stage.id"
                    :scale-label="'protocol.total_percent' | trans"
                    :stage-info="stage.id"
                    :persentMax="true"
                    v-bind:show-legend="dataset.length > 1"
                    v-bind:list-chart-date="measurements.labels"
                    v-bind:y-axes-begin-at-zero="true"
                    v-bind:vertical-line-point=changes
                    v-bind:linedatasets="trendLinePoint"
                    v-on:popup-show="popupShow"
                    :labelText="'%'"
                    :aspect-ratio=false
                    :height="340"
                    :width=null
        />

        <h4 class="chart__title mb-3">{{'protocol.stimulus_mastering_chart' | trans}} "{{stage.description}}"</h4>
        
      </div>

      <div class="mt-3 col-md-3" v-if="measurements && xLabels && xLabels.length >= 3 && measurements.tasksChart.length === 1">
        <mdc-switch v-model="levelLineChecked">{{ 'protocol.levelLine' | trans }}</mdc-switch>
        <mdc-switch v-model="trendLineChecked">{{ 'protocol.trendLine' | trans }}</mdc-switch>
        <mdc-switch v-model="ScatterLineChecked">{{ 'protocol.scatterLine' | trans }}</mdc-switch>
      </div>
    </div>

    <div class="row">

      <div class="col-12" v-if="measurements && xLabels && datasetImproved && datasetImproved[0].data.length">

        <line-chart class="row mt-5" v-bind:datasets="datasetImproved"
                    v-if="xLabels.length"
                    :chart-id="'stageChartImproved_' + stage.id"
                    :scale-label="'report.label_improve_prompt' | trans"
                    :stage-info="stage.id"
                    :persentMax="true"
                    v-bind:list-chart-date="measurements.labels"
                    v-bind:y-axes-begin-at-zero="true"
                    v-bind:vertical-line-point=changes
                    :labelText="'%'"
                    :is-mobile="isMobile"
                    :aspect-ratio=false
                    :height="340"
                    :width=null
        />

        <h4 class="chart__title mb-3">{{'protocol.stimulus_improved_chart' | trans}} "{{stage.description}}"</h4>

      </div>




    </div>

    <div class="row" v-if="measurements && measurements.tasksChart">

      <div class="col-12"  v-for="taskChart in measurements.tasksChart" v-if="taskChart.promptChartData.values && taskChart.promptChartData.values.length">

        <prompt-chart
            :promt-chart-values="taskChart.promptChartData.hintResultsData"
            :promt-chart-levels="hintRezultsLevels"
            :stage-id="stage.id"
            :chosen-stimul="chosenStimul"
            :protocol-id="protocolId"
            :description="taskChart.description + '. ' + stage.description"
            :index="0"
            :isSimple="true"
        />

      </div>

    </div>
  
    <div v-if="isModalVisible">

      <chart-popup :visible="isModalVisible"
                   :isSimple="true"
                   v-on:close="onClose"
                   :stimulName="chosenStimul[0].stimulusName"
                   :chartType="type"
                   :stage-id="stage.id"
                   :graphTitle="'protocol.stimulus_mastering_chart' | trans"
                   :stimulId="chosenStimul[0].id"
                   :protocolId="protocolId"
                   :dataPoint="dataPoint">
      </chart-popup>

  
    </div>
   

  </div>


</template>

<script>

  import axios from 'axios';
  import {mapGetters} from 'vuex';
  import TableView from '../../../common/table/components/TableView';
  import lang from '../../../lang/translator';
  import moment from 'moment';
  import forEach from 'lodash/forEach';
  import {LineNonNumericYChart, LineChartDataset, LineChart} from '../../../common/chart';
  import map from 'lodash/map';
  import Loader from '../../loader/components/Loader';
  import ChartPopup from './ChartPopup';
  import values from 'lodash/values';
  import PromptChart from '../../chart/component/PromptChart';
  import {trendLine} from '../../../common/mixins/trendLine';
  
  export default {
    props: ['stage', 'protocolId', 'rangeDateStartTimestamp', 'rangeDateEndTimestamp', 'isApplyFilter', 'chosenStimul'],
    components: {
      TableView, LineChart, LineChartDataset, LineNonNumericYChart, Loader, ChartPopup, PromptChart
    },

    data() {
      return {
        isChange: false,
        list: [],
        persentMax: true,
        apiUrl: '/protocols/assigned/',
        measurements: null,
        changesLine: [],
        withoutData: false,
        loaded: true,
        isModalVisible: false,
        dataPoint: null,
        selectedStageId: null,
        yLabels: null,
        xLabels: null,
        changes: null,
        hintRezultsLevels: [],
        type: 1,
        dataset: null,
        datasetImproved: null,
        levelLineChecked: false,
        trendLineChecked: false,
        ScatterLineChecked: false,
        trendLinePoint: null,
      };
    },
    mixins: [trendLine],
    computed: {

      ...mapGetters('mobile', [
        'isMobile',
      ]),
      
    },

    async created() {
      //this.chartShow();
    },

    methods: {

      toLocaleDate: function (date) {
        return moment(date, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY');
      },

      startedAt(h, row) {
        return row.startedAt ? this.toLocaleDate(row.startedAt.date) : '';
      },

      masteredAt(h, row) {
        return row.masteredAt ? this.toLocaleDate(row.masteredAt.date) : '';
      },

      async requestFunction (data) {
        this.isChange = false;
        return this.onSendRequest(this.options.perPage, data.page);
      },

      popupShow(data,stageId){

        if(this.chosenStimul.length === 1){
          this.dataPoint = moment.utc(data.x, 'DD.MM.YYYY').unix();
          this.selectedStageId = stageId;
          this.type = 1;
          this.isModalVisible = true;
        }

      },


      onClose() {
        this.isModalVisible = false;
      },

      fetchDatasetForStageChart(datasetChart){

        let chartData = [];
        let chartDataImproved = [];
        let pointStyle = "rect";

        forEach(datasetChart, (chart, indexChart) => {

          if (indexChart == 1) {
            pointStyle = "circle";
          }
          if (indexChart == 2) {
            pointStyle = "rectRot";
          }
          if (indexChart == 3) {
            pointStyle = "triangle";
          }

          let dataset = new LineChartDataset({
            data: chart.independentChartData.values,
            label: chart.description,
            pointStyle: pointStyle
          });

          let datasetImproved = new LineChartDataset({
            data: chart.improvedChartData.values,
            label: chart.description,
            pointStyle: pointStyle
          });

          chartData.push(dataset);
          chartDataImproved.push(datasetImproved);

        });

        this.dataset = chartData;
        this.datasetImproved = chartDataImproved;

        return chartData;
      },



      fetchDatasetForStageChartChanges(datasetChartChanges){

        let changes = [];

        forEach(datasetChartChanges, change =>{
          changes.push({
            x: lang.get('protocol.changes') + '_' + change.id,
            index: change.id,
            isImportant: change.isImportant,
            comment: change.comment
          })
        });

        return changes;
      },
      
      async chartShow(){
        this.loaded = false;
        this.changesLine = [];
        this.trendLinePoint = null;
        let dataForChart = [];
        let chosenTaskIds = map(this.chosenStimul, 'id');

        let url = this.apiUrl + 'simple/' + this.protocolId + '/mensuration/' + this.stage.id;
        let response = await axios.get(url, {
          params: {
            startDate: this.rangeDateStartTimestamp,
            endDate: this.rangeDateEndTimestamp,
            globalTaskIds: JSON.stringify(chosenTaskIds)
          }
        });

        if (response){
          this.measurements = response.data.data;
          this.changes = this.fetchDatasetForStageChartChanges(this.measurements.changes);
          this.yLabels = response.data.data.yLabels;
          this.xLabels = response.data.data.labels;
          this.hintRezultsLevels = map(this.measurements.levels, hint => {return hint.description});
          this.fetchDatasetForStageChart(this.measurements.tasksChart);
        }

      
        this.loaded = true;
      },

      onSendRequest: async function (perPage, page) {
        this.list = [];

        let url = this.apiUrl + 'simple/' + this.protocolId + '/stimuli-introduced-mastered-history/';

        let params = {
          perPage: perPage,
          page: page,
          stageId: this.stage.id,
        };
        let response = await axios.get(url, {params: params});
        this.list = response.data.data.items;
        return response;
      },

      
    },
    watch: {
      isApplyFilter(apply) {
        if (apply) {
          this.chartShow();
        }
      },
    }

  };
</script>



// WEBPACK FOOTER //
// src/modules/dashboardParent/components/CurrentStageSimple.vue